<!-- 변경 시작! -->
<template>
  <!-- 지면 영역 : 양/단면 선택버튼으로 toggle -->
  <v-container
    class="bg-color-custom withoutSideAndHeader"
    style="position: relative; z-index: auto; padding: 0px;"
  >
    <div
      v-if="mobile"
      v-show="bgVisible"
      id="paper-background"
      ref="paperBgEl"
    >
      <img
        ref="paperBgImgEl"
        src=""
      >
    </div>
    <div
      id="paper"
      class="paperCenterHeight "
      style="display: block;"
      oncontextmenu=" event.preventDefault();"
    />
    <div id="image-ruler" />
    <!-- 확대/축소 버튼 -->
    <div
      v-if="userMobileStore.uiVisible.paperCenterImage.paperCenterControls"
      style="position: absolute; right: 0px; bottom: 0px; z-index: 50;"
    >
      <v-hover v-slot="{ isHovering, props }">
        <div
          id="imageControlBtns"
          :class="{ 'hover-zoom-btns': isHovering && !mobile }"
          class="d-flex flex-column justify-center align-center ma-6"
          v-bind="props"
          style="
                background-color: white;
                height: 160px;
                width: 34px;
                border: 2px solid #bebebf;
                border-radius: 5px;
                transition: opacity 0.2s ease;
              "
          :style="{ opacity: isHovering && !mobile ? 1 : 0.7 }"
          @touchstart="handleMobileTouch(true)"
          @touchend="handleMobileTouch(false)"
        >
          <!-- 1면 이동 버튼 -->
          <v-tooltip
            location="left"
            transition="null"
            opacity="0"
            offset="7"
            width="79"
            :disabled="userJS.isHandheldDevice()"
          >
            <template #activator="{ props: tooltip }">
              <div style="border-bottom: 1px solid #bebebf">
                <v-btn
                  id="toFirstPageBtn"
                  icon="mdi-page-first"
                  :ripple="false"
                  elevation="0"
                  style="width: 30px; height: 30px; color: rgba(102, 102, 102, 0.8)"
                  v-bind="tooltip"
                  @click="$emit('to-target-page');"
                />
              </div>
            </template>

            <!-- 툴팁 내용 -->
            <div
              class="text-caption d-flex align-center"
            >
              1면으로 이동
            </div>
          </v-tooltip>

          <!-- 마지막 면으로 이동 버튼 -->
          <v-tooltip
            location="left"
            transition="null"
            opacity="0"
            offset="7"
            width="109"
            :disabled="userJS.isHandheldDevice()"
          >
            <template #activator="{ props: tooltip }">
              <div style="border-bottom: 1px solid #bebebf">
                <v-btn
                  id="toLastPageBtn"
                  icon="mdi-page-last"
                  :ripple="false"
                  elevation="0"
                  style="width: 30px; height: 30px; color: rgba(102, 102, 102, 0.8)"
                  v-bind="tooltip"
                  @click="$emit('to-target-page', 1);"
                />
              </div>
            </template>

            <!-- 툴팁 내용 -->
            <div
              class="text-caption d-flex align-center"
            >
              마지막 면으로 이동
            </div>
          </v-tooltip>

          <v-tooltip
            location="left"
            transition="null"
            opacity="0"
            offset="7"
            width="74"
            :disabled="userJS.isHandheldDevice()"
          >
            <template #activator="{ props: tooltip }">
              <div style="border-bottom: 1px solid #bebebf">
                <v-btn
                  id="zoomIn"
                  icon="mdi-plus"
                  :ripple="false"
                  elevation="0"
                  v-bind="tooltip"
                  style="width: 30px; height: 30px; color: rgba(102, 102, 102, 0.8)"
                />
              </div>
            </template>

            <!-- 툴팁 내용 -->
            <div
              class="text-caption d-flex align-center"
            >
              이미지 확대
            </div>
          </v-tooltip>

          <v-tooltip
            location="left"
            transition="null"
            opacity="0"
            offset="7"
            width="74"
            :disabled="userJS.isHandheldDevice()"
          >
            <template #activator="{ props: tooltip }">
              <div style="border-bottom: 1px solid #bebebf">
                <v-btn
                  id="zoomOut"
                  icon="mdi-minus"
                  :ripple="false"
                  elevation="0"
                  v-bind="tooltip"
                  style="width: 30px; height: 30px; color: rgba(102, 102, 102, 0.8)"
                />
              </div>
            </template>

            <!-- 툴팁 내용 -->
            <div
              class="text-caption d-flex align-center"
            >
              이미지 축소
            </div>
          </v-tooltip>

          <v-tooltip
            location="left"
            transition="null"
            opacity="0"
            offset="7"
            width="109"
            :disabled="userJS.isHandheldDevice()"
          >
            <template #activator="{ props: tooltip }">
              <div>
                <v-btn
                  id="goHome"
                  icon="mdi-fullscreen-exit"
                  :ripple="false"
                  elevation="0"
                  v-bind="tooltip"
                  style="width: 30px; height: 30px; color: rgba(102, 102, 102, 0.8)"
                />
              </div>
            </template>

            <!-- 툴팁 내용 -->
            <div
              class="text-caption d-flex align-center"
            >
              이미지 크기 초기화
            </div>
          </v-tooltip>
        </div>
      </v-hover>
    </div>
    <!-- 이전/다음 기사 이동 버튼 -->
    <div
      v-if="userMobileStore.uiVisible.paperCenterImage.paperPrevNextArrows"
      class="prev-next prev"
    >
      <v-btn
        id="prevBtn"
        ref="prevBtn"
        class="mdil"
        icon="mdi-chevron-left"
        :ripple="false"
        elevation="0"
        @click="$emit('pre-next')"
      />
    </div>
    <div
      v-if="userMobileStore.uiVisible.paperCenterImage.paperPrevNextArrows"
      class="prev-next next"
    >
      <v-btn
        id="nextBtn"
        ref="nextBtn"
        class="mdil"
        icon="mdi-chevron-right"
        :ripple="false"
        elevation="0"
        @click="$emit('pre-next', 1)"
      />
    </div>
  </v-container>
</template>

<script setup>
  import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
  import { useDisplay } from 'vuetify'
  import OpenSeadragon from 'openseadragon';
  import Konva from 'konva';
  import axios from 'axios';
  import { useUserStore, useUserInfoStore, useFuncStore, useStaticFinalVariableStore, useUserMobileStore } from '@/store';

  import { userJS } from '@/assets/js/index';

  //props의 경우 값을 할당하려면 반드시 ref에 넣어줘야됨
  const props = defineProps({
    vh: Number,
    papers: Array,
    thumbIdx: Number,
    pageSide: Number,
    searchKeyword: Array,
    scrapData: Array,
    scrapSerialList: Array,
    selectedSerial: String,
    mediaSeq: String,
    isFullScreen: Boolean,
    articleDetailViewData: Object,
    drawer5: Boolean,
    tab: String,
    isTtsPlaying: Boolean,
  });
  // 이전/다음 지면 함수
  const $emit = defineEmits(['pre-next', 'detail-view', 'to-target-page', 'add-bookmark', 'paper-loaded']);
  //store
  const userStore = useUserStore();
  const userInfoStore = useUserInfoStore();
  const funcStore = useFuncStore();
  const pageSerialOf = (serial) => serial?.substring(0, 15); // /info.json 응답 에러로 인해 로딩면(loading) 상태인 지면에 속하는 기사serial 모음
  const staticVarStore = useStaticFinalVariableStore(); //고정 값들이 저장되어 있는 Store
  const userMobileStore = useUserMobileStore();
  //vuetify 반응형 display 속성
  const { mobile, width } = useDisplay();
  // element 들
  const prevBtn = ref(null)   // 이전 페이지
  , nextBtn = ref(null);      // 이후 페이지

  // userMobileStore에서 계산된, 중앙 이미지 로드 모드 (PC=항상 AUTO_TILE, 모바일=설정값)
  const mode = computed(() => userMobileStore.paperCenterImage.$imageLoadMode || 'AUTO_TILE');

  /**
  * script 내부 함수들 묶음
  * @function sideChange(array) - 양/단면 변경시 공통 함수
  * @function buttonOpacityChange(boolean, boolean) - 첫 페이지 로드 시 '기사 이전 버튼' opacity 조절하기 위해 onMounted()에서 buttonOpacityChange(false, true) 실행함.
  */
  let _func = {
    sideChange: function(array) {
      let clone = array.slice();
      clone.map((a, i) => a.idx = i )
      let arr = [];
      let first = clone.shift();
      let last = clone.pop();

      // 첫번째 지면 넣기
      if (props.pageSide === 2) {// 양면일 때 endpaper 만들기 위함.
        const copy = JSON.parse(JSON.stringify(first)); // first의 clone.
        const endpaper = {// 지면 안의 다른 기사 정보를 담지 않는 이유 : 기사 영역 선택이 안 되도록 하기 위함.
          Pdf_height: copy.Pdf_height,
          Pdf_width: copy.Pdf_width,
          Serial: copy.Serial,
          url: copy.url,
        };
        endpaper.endpaper = true;
        endpaper.firstEndpaper = true;// 첫 페이지의 속지이다.
        arr.push([endpaper, first]);
      } else arr.push([first]);

      while(clone.length > 0){
        if(clone[0].doublepage) {// 통판 넣기
          arr.push( clone.splice(0, 1) );
        } else if(props.pageSide == 2 && (clone[0].localpage || clone[0].isNextLocalpage)) { // 속지가 있는 지면 넣기.
          let localpage = clone.splice(0, 1);
          const copy = JSON.parse(JSON.stringify(localpage[0]));
          const endpaper = {// 지면 안의 다른 기사 정보를 담지 않는 이유 : 기사 영역 선택이 안 되도록 하기 위함.
            Pdf_height: copy.Pdf_height,
            Pdf_width: copy.Pdf_width,
            Serial: copy.Serial,
            url: copy.url,
          };
          endpaper.endpaper = true;
          arr.push( [localpage[0], endpaper] );
        } else {
          arr.push( clone.splice(0, props.pageSide) );
        }
      }

      // 마지막 지면 넣기
      if (props.pageSide === 2) {
        const copy = JSON.parse(JSON.stringify(last)); // last의 clone.
        const endpaper = {
          Pdf_height: copy.Pdf_height,
          Pdf_width: copy.Pdf_width,
          Serial: copy.Serial,
          url: copy.url,
        };
        endpaper.endpaper = true;
        endpaper.lastEndpaper = true;// 마지막 페이지의 속지이다.
        arr.push([last, endpaper]);
      } // 양면일 때 endpaper 만들기 위함.
      else arr.push([last]);
      return arr;
    },
    buttonOpacityChange: function(prevBtnActive, nextBtnActive){
      let pOpacity = 1, nOpacity = 1, off = 0.2;
      if( !prevBtnActive && nextBtnActive ) pOpacity = off;  // false, true
      else if( prevBtnActive && !nextBtnActive ) nOpacity = off; // true, false

      const pBtn = prevBtn.value?.$el;
      const nBtn = nextBtn.value?.$el;
      if(!pBtn || !nBtn) return; // 옵션 값에 의해 버튼이 없는 경우 방어 코드
      pBtn.style.transition = 'opacity 0s';
      pBtn.style.opacity = pOpacity;
      pBtn.style.cursor = (pOpacity == off ? 'no-drop' : 'pointer');
      nBtn.style.transition = 'opacity 0s';
      nBtn.style.opacity = nOpacity;
      nBtn.style.cursor = (nOpacity == off ? 'no-drop' : 'pointer');
    }
  }
  function handleMobileTouch(isOn) { // mobile인 경우 hover 기능을 대체해주는 함수.
    let imageControlBtns = document.querySelector('#imageControlBtns');
    if (isOn) {// 클릭한 상태
      imageControlBtns.style.opacity = '1';
      imageControlBtns.classList.add('hover-zoom-btns');
    } else {
      imageControlBtns.style.opacity = '0.7';
      imageControlBtns.classList.remove('hover-zoom-btns');
    }
  }

  // --- overlay 이미지(ObjectURL) 캐시 ---
  const overlayObjUrlCache = new Map(); // key: src URL, value: objectURL
  async function getOverlayObjectUrl(src) {
    if (overlayObjUrlCache.has(src)) return overlayObjUrlCache.get(src);
    const { data: blob } = await axios.get(src, {
      responseType: 'blob',
      withCredentials: true,
    });
    const objUrl = URL.createObjectURL(blob);
    overlayObjUrlCache.set(src, objUrl);
    return objUrl;
  }

  async function makingOverlay(image, i){// userStore.limitation 값에 따라 지면 위에 덮어씌워질 오버레이 생성 함수
    const blurSrc = await getOverlayObjectUrl(image.src); // axios -> blob -> objectURL
    let overlayElement = document.createElement('div');
    overlayElement.innerHTML =
      `<div style="position: relative; width: 100%; height: 100%;">
        <img src='${blurSrc}' style='width: 100%; height: 100%; filter: blur(5px) opacity(0.5);' />
        <img src='${require("../../assets/images/lock-outline.png")}' style='position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); width: 45px; height: 45px; filter: none;' />
      </div>`;
    overlayElement.id = 'example-overlay';
    overlayElement.className = 'highlight';

    viewer.addOverlay({
      element: overlayElement,
      location: new OpenSeadragon.Rect(image.Pdf_width*i, 0, Number(image.Pdf_width), Number(image.Pdf_height)),
      placement: OpenSeadragon.Placement.CENTER,
    });
  }

  let firstEndpaperContent = window.location.hostname === 'localhost' ? `${require("../../assets/images/npaperLogo.png")}` : `${userInfoStore.LOGO}`;
  let endpaperContent = `${require("../../assets/images/replacepg.png")}`// 이미지 받아서 적용할 것 (+)
  let lastEndpaperContent = `${require("../../assets/images/lastpg.png")}`
  function makingEndpaper(image, i) {// 속지 오버레이 생성하면서 그 안에 이미지 띄우는 함수

    let content = image.firstEndpaper ? firstEndpaperContent : image.lastEndpaper ? lastEndpaperContent : endpaperContent;
    let size = image.firstEndpaper ? '35%' : '100%';

    let overlayElement = document.createElement('div');
    overlayElement.innerHTML =
      `<div style="width: 100%; height: 100%;
        background-color: #E0E8F9;
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url(${content});
        background-size: ${size}; background-position: center; background-repeat: no-repeat;">
      </div>`;
    viewer.addOverlay({
      element: overlayElement,
      location: new OpenSeadragon.Rect(image.Pdf_width * i, 0, Number(image.Pdf_width), Number(image.Pdf_height)),
      placement: OpenSeadragon.Placement.CENTER,
    });
  }

  let loadingpaperContent = `${require("../../assets/images/loadingpg.png")}`

  let imageData, viewer, tileSources, canvasResizeCheck = [], ready = false;
  // 이 뷰(단/양면)에서 "항상" 사용할 홈 사각형. 로딩 중/로딩 완료 후 동일 뷰 유지용.
  let currentHomeRect = null;
  let isLoadingView = false; // 이번 뷰에서 loadingBase를 띄울 때에는 Konva를 숨길지 여부

  let copiedInfoJsonRaw = null;   // /info.json api 호출 시 에러났을 때, 대체 이미지를 띄우기 위해, 최초 정상 로딩된 info.json 원본 그대로 보관
  // 매번 '원본을 깊은 복사'해서 변환
  function makeOsdIiifInfo(src) {
    const info = structuredClone(src);                  // 절대 원본을 변형하지 않음
    if (!info['@id'] && info.id) info['@id'] = info.id; // 이미 @id 있으면 그대로 둠
    return info;
  }

  function getIiifBaseUrl(info) {
    // IIIF v3는 id, v2는 @id. 둘 다 섞여 올 수 있어서 방어.
    return info?.id || info?.['@id'];
  }
  // 모바일에도 항상 해상도가 높은 원본을 다루기 위함.
  // full/max 단일 이미지를 가져오지 않고, 최대 maxTiles개 타일로 쪼개서 region 요청으로 가져옴
  function makeFullMaxTileSource(info, format = 'jpg', maxTiles = 16, useRegionTiles = true) {
    const base = getIiifBaseUrl(info);
    const width  = Number(info?.width)  || 0;
    const height = Number(info?.height) || 0;

    if (!base || !width || !height) {
      // base 자체가 없으면 아예 null로 돌려서 상위에서 osdInfo를 쓰게 하거나,
      // 적어도 빈 문자열 URL을 만들지 않게.
      return null;
    }

      // 1) "한 번에 가져오기" 모드: full/max URL을 1번만 요청하도록 1타일 TileSource 구성
    if (!useRegionTiles) {
      const tileSize = Math.max(width, height); // 1타일이 되도록 크게
      const ts = new OpenSeadragon.TileSource({
        width,
        height,
        tileSize,
        tileOverlap: 0,
        minLevel: 0,
        maxLevel: 0,
      });

      ts.getTileUrl = function () {
        // IIIF 단일 이미지 요청 (1번 요청)
        return `${base}/full/max/0/default.${format}`;
      };

      return ts;
    }

    // 2) 기존 모드: region으로 쪼개서 가져오기
    // 최대 타일 수 → 한 변 grid(예: 16이면 4x4)
    const grid = Math.max(1, Math.ceil(Math.sqrt(maxTiles)));

    // tileSize를 크게 잡을수록 타일 개수는 줄어듦 (<= grid x grid 보장)
    const tileSize = Math.ceil(Math.max(width / grid, height / grid));

    const ts = new OpenSeadragon.TileSource({
      width,
      height,
      tileSize,
      tileOverlap: 0,
      minLevel: 0,
      maxLevel: 0,
    });

    ts.getTileUrl = function (level, x, y) {
      const left = x * tileSize;
      const top  = y * tileSize;

      const w = Math.min(tileSize, width - left);
      const h = Math.min(tileSize, height - top);

      const region = `${left},${top},${w},${h}`;
      return `${base}/${region}/max/0/default.${format}`;
    };

    return ts;
  }

  // 로딩 대체 이미지를 OpenSeadragon의 '단일 이미지' tileSource로 사용
  function makeFallbackTileSource(image, i, dim) {
    const n = v => Number.isFinite(Number(v)) ? Number(v) : undefined;
    const FALLBACK_W = n(dim?.w) || n(image?.Pdf_width)  || 2315;
    const FALLBACK_H = n(dim?.h) || n(image?.Pdf_height) || 3138;

    // 기사 원본 정보 따로 보존
    if (image?.Serial && image?.Articles && !articlesBySerial.has(image.Serial)) {
      articlesBySerial.set(image.Serial, structuredClone(image.Articles));
    }

    const base = Object.assign(
      {
        type: 'image',
        buildPyramid: false,
        imgJson: { type: 'image', url: loadingpaperContent },
        loadingBase: true,
      },
      structuredClone(image), // 깊은 복사
      { Pdf_width: FALLBACK_W, Pdf_height: FALLBACK_H }
    );

    // 로딩 베이스에선 기사 제거
    delete base.Articles;

    return base;
  }

  /* 20260108 모바일에서 (고해상도 이미지 불러오기 전에 시간 차 줄이기 위한) 저해상도 이미지 background 생성 */
  const paperBgEl = ref(null);
  const paperBgImgEl = ref(null);

  let bgTokenSeq = 0;         // 이미지 변경마다 증가 (레이스 방지)
  let bgActiveToken = 0;      // 현재 유효 토큰
  let bgLastDim = { w: 2315, h: 3138 }; // 마지막 알려진 W/H (fallback)
  const bgVisible = ref(true);

  function calcHomePixelRect(worldW, worldH) {
    // OSD 컨테이너(px)
    const size = viewer?.viewport?.getContainerSize?.();
    const cw = size?.x || document.getElementById(viewer?.id)?.offsetWidth || 0;
    const ch = size?.y || document.getElementById(viewer?.id)?.offsetHeight || 0;
    if (!cw || !ch || !worldW || !worldH) return null;

    // home은 "월드 사각형을 컨테이너에 맞춰 fit" → 비율 유지 letterbox
    const scale = Math.min(cw / worldW, ch / worldH);
    const w = worldW * scale;
    const h = worldH * scale;
    const x = (cw - w) / 2;
    const y = (ch - h) / 2;

    return { x, y, w, h };
  }

  function syncBgGeometry(worldW, worldH) {
    if (!mobile.value) return;
    const bg = paperBgEl.value;
    const img = paperBgImgEl.value;
    if (!bg || !img || !viewer) return;

    const rect = calcHomePixelRect(worldW, worldH);
    if (!rect) return;

    img.style.transform = `translate(${rect.x}px, ${rect.y}px)`;
    img.style.width = `${rect.w}px`;
    img.style.height = `${rect.h}px`;
  }

  function getLowResUrlFromSerial(serial, format='jpg') {
    // buildInfoUrl(serial) = .../info.json 이었지? → base만 뽑아서 full/620로
    const infoUrl = buildInfoUrl(serial);
    const base = infoUrl.replace(/\/info\.json(\?.*)?$/, '');
    return `${base}/full/620,/0/default.${format}`;
  }

  function showBgForSerial(serial, worldW, worldH) {
    if (!mobile.value) return;

    bgActiveToken = ++bgTokenSeq;
    bgLastDim = { w: Number(worldW) || bgLastDim.w, h: Number(worldH) || bgLastDim.h };
    bgVisible.value = true; // paperBgEl DOM 나타남.

    const img = paperBgImgEl.value;
    if (img) {
      // 이전 요청 취소(브라우저가 이전 이미지 요청을 중단)
      img.src = '';
      img.decoding = 'async';
      img.loading = 'eager';
      img.src = getLowResUrlFromSerial(serial, 'jpg');
    }

    syncBgGeometry(bgLastDim.w, bgLastDim.h);
  }

  let hideBgTimer = null;
  function hideBg() {
    if (!mobile.value) return;

    // 이전 예약이 있으면 취소
    if (hideBgTimer) {
      clearTimeout(hideBgTimer);
      hideBgTimer = null;
    }

    hideBgTimer = setTimeout(() => {
      bgVisible.value = false; // (v-show라면)
      hideBgTimer = null;
    }, 100); // 0.1초
  }

  // 리사이즈/회전 대응(배경 위치 다시 맞추기)
  function onResizeSyncBg() {
    if (!mobile.value) return;
    if (!bgVisible.value) return;
    syncBgGeometry(bgLastDim.w, bgLastDim.h);
  }
  // 언마운트에 해제:
  onUnmounted(() => {
    window.removeEventListener('resize', onResizeSyncBg);
  });
  /* 20260108 모바일에서 (고해상도 이미지 불러오기 전에 시간 차 줄이기 위한) 저해상도 이미지 background 생성 끝! */

  // 4. 선택한 이미지 데이터 적용
  async function imageViewer_Images(idx = 0){       // 인덱스를 제공하지 않고 호출하면 idx 기본값 = 0

    // 이미지 로딩 상태 초기화
    isLoadingView = false;

    // 로딩면(loadingBase) 폴러/상태 전부 초기화
    stopAllPollers();
    alertedThisView = false;
    itemBySerial.clear();
    boundsBySerial.clear();
    loadingOverlayBySerial.clear();
    // articlesBySerial는 계속 유지해도 되지만, 안전하게 비움
    articlesBySerial.clear();

    // 이번 뷰에서 로딩 실패한 면들의 표시명(Name) 모으는 버퍼
    const failedTargets = [];

    // 데이터 초기화
    imageData = _func.sideChange(props.papers);
    // 이전 이후 버튼 활성화
    let pBtnOn=true, nBtnOn=true, max = imageData.length;
    if( idx == max-1 ) nBtnOn = false;   // 다음 기사 버튼
    else if( idx == 0 ) pBtnOn = false;  // 이전 기사 버튼
    _func.buttonOpacityChange(pBtnOn, nBtnOn);
    // typeof 맞춰 주기
    let obj = imageData[idx];
    if( !Array.isArray(obj) ) obj = [obj];

    // 20260108 배경 이미지용 low-res 즉시 표시
    // obj 만든 직후쯤 (단면 기준이라 obj[0]만 보면 됨)
    if (mobile.value && mode.value === 'PREVIEW_THEN_ORIGINAL' && obj?.[0]?.Serial) {
      const w0 = Number(obj[0].Pdf_width)  || 2315;
      const h0 = Number(obj[0].Pdf_height) || 3138;
      showBgForSerial(obj[0].Serial, w0, h0); // OSD 로딩과 무관하게 즉시
    } else if (mobile.value) {
      // 다른 모드에서는 배경을 사용하지 않으므로 숨김 처리(잔상 방지)
      bgVisible.value = false;
    }

    // buildPyramid: 이미지 피라미드 구축 여부 (false로 설정하여 이미지를 타일로 나누지 않음)
    tileSources = [];

    // 양면에서 월드 좌표를 먼저 고정하기 위한 선행 타일 참조
    let preItem = null;    // addTiledImage로 넣은 '선행 타일'의 item
    let preAdded = false;  // 선행 타일을 넣었는지 여부

    await Promise.all(
      obj.map(async (image, i) => {
        //시리얼은 존재하지만 기사들이 없는 화면들이 있다 대표 예로 통판!
        // if(!image || !('Articles' in image)) return true;
        // if(props.pageSide == 2) { // 양면인 경우에 image에 Articles가 없는 경우(속지. endpaper == true임.)가 있음.
        //   if(!image.Serial || !image || !('Articles' in image)) return true;
        // }

        if(!image) return;
        let serial = image.Serial;

        // 초기 로딩도 같은 규칙으로 /info.json URL 생성
        const infoUrl = buildInfoUrl(serial);

        let errorFlag  = false;

        let imgJson = await axios.get(infoUrl)
        .then()
        .catch(error => {
          errorFlag = true;
          // (변경) 지금은 알림 띄우지 않고 대상만 수집
          failedTargets.push(image?.Name || serial);
          // 폴링은 그대로 시작
          startPollFor(serial);
        });

        // let id_name = '@id';
        // imgJson.data[id_name] = imgJson.data.id;
        // delete imgJson.data.id;
        // // 지면 이미지 크기 정보 존재 여부 확인 초판의 경우 그냥 원본 크기라 없을수 있다고 함
        // image.Pdf_width = Number(image.Pdf_width) || imgJson.data.width;
        // image.Pdf_height = Number(image.Pdf_height) || imgJson.data.height;
        // tileSources[i] = (Object.assign({type: 'image', buildPyramid: false, imgJson: imgJson.data}, image));

        if (!errorFlag) {
          // 정상: info.json 사용
          const osdInfo = makeOsdIiifInfo(imgJson.data);
          if (!copiedInfoJsonRaw) copiedInfoJsonRaw = imgJson.data; // 최초 백업
          image.Pdf_width  = Number(image.Pdf_width)  || Number(osdInfo.width);
          image.Pdf_height = Number(image.Pdf_height) || Number(osdInfo.height);

        // 로딩 이미지 로딩 방식 AUTO_TILE: info.json 기반(타일/레벨 자동)
        if (mode.value === 'AUTO_TILE') {
          tileSources[i] = Object.assign(
            { type:'image', buildPyramid:false, imgJson: osdInfo },
            image
          );
        }
        else if ( mode.value === 'ORIGINAL_ONCE'       // 로딩 이미지 로딩 방식 ORIGINAL_ONCE: full/max 단일 이미지를 "1회 요청"하는 TileSource(1타일)
          || mode.value === 'PREVIEW_THEN_ORIGINAL') { // 로딩 이미지 로딩 방식 PREVIEW_THEN_ORIGINAL: 저화질 배경(showBgForSerial) 먼저, 이후 ORIGINAL_ONCE와 동일하게 1회 로드된 원본으로 교체
          const fullMaxOnceTs = makeFullMaxTileSource(osdInfo, 'jpg', 8, false); // useRegionTiles=false => full/max 단일
          tileSources[i] = Object.assign(
            { type:'image', buildPyramid:false, imgJson: fullMaxOnceTs || osdInfo },
            image
          );
        }
        // 방어: 알 수 없는 값이면 AUTO_TILE로
        else {
          tileSources[i] = Object.assign(
            { type:'image', buildPyramid:false, imgJson: osdInfo },
            image
          );
        }

          // 현재 면은 로딩중이 아님을 명시 (이전에 true였을 수도 있으니 동기화)
          funcStore.$setPageLoading(pageSerialOf(image.Serial), false);

          // 20260108 모바일 배경 이미지 처리
          // info.json 정상 응답 받으면 더 정확한 W/H로 보정
          if (mobile.value && mode.value === 'PREVIEW_THEN_ORIGINAL' && i === 0) {
            bgLastDim = { w: Number(image.Pdf_width), h: Number(image.Pdf_height) };
            syncBgGeometry(bgLastDim.w, bgLastDim.h);
          }

        } else {
          // 에러: 대체이미지를 '베이스'로 사용 (오버레이 NO)
          let dim = null;
          if (copiedInfoJsonRaw) {
            const info = makeOsdIiifInfo(copiedInfoJsonRaw);
            dim = { w: info.width, h: info.height };
          }
          tileSources[i] = makeFallbackTileSource(image, i, dim);
          isLoadingView = true; // Konva 감추기
          // 로딩면 등록 (상세보기에서 덮개를 씌우기 위함)
          funcStore.$setPageLoading(pageSerialOf(image.Serial), true);
        }
      })
    );

    // 실패 수집 후 알림 부분 (양면이라도 한쪽만 실패해도 알림)
    if (failedTargets.length > 0 && !alertedThisView) {
      alertedThisView = true;
      alert(
        `지면이 생성 중입니다. 잠시만 기다려주세요.\n- 대상 : ${Array.from(new Set(failedTargets)).join(', ')}`
      );
    }

    if( !tileSources.length ) return;

    let addedCount = 0; // 이번 페이지에서 addTiledImage 몇 개 했는지
    let doneCount = 0;      // success 완료 개수

    // 지면 이미지 그리기 액션
    let _drawLoop = () => {
      tileSources.map((image, i) => {

        // loadingBase든 아니든 "자리"를 먼저 잡기 위해 항상 addTiledImage 호출
        addedCount++;

        const isLoading = !!image.loadingBase;
        viewer.addTiledImage({
          tileSource: image.imgJson,  // 이미지 하나가 객체 하나
          //x: i,                     // 이 값을 조정하여 다른 이미지와 겹치지 않도록 설정. 0과 1사이의 index
          //y: 0,
          //index: i + 1,
          opacity: isLoading
                  ? 0 // 로딩면은 타일 자체는 안 보이게 하고(자리는 잡고), 오버레이로 보여줌
                  : image.endpaper ? 0 : (userStore.limitation && image.idx > userStore.limitation-1) ? 0 : 1,
          fitBounds: new OpenSeadragon.Rect(image.Pdf_width*i, 0, Number(image.Pdf_width), Number(image.Pdf_height)),
          success: function(ev) {
            // 공통: 현재 면의 자리/아이템을 시리얼로 매핑
            const rect = new OpenSeadragon.Rect(image.Pdf_width * i, 0, Number(image.Pdf_width), Number(image.Pdf_height));
            boundsBySerial.set(image.Serial, rect);
            itemBySerial.set(image.Serial, ev.item);

            if (isLoading) { // 로딩 면(image.loadingBase)이라면.
              // 로딩 오버레이 얹고 핸들 저장 (나중에 refreshOne에서 제거)
              const overlayElement = document.createElement('div');
              overlayElement.innerHTML =
                `<div style="width:100%;height:100%;background-color:#E0E8F9;
                  display:flex;justify-content:center;align-items:center;
                  background-image:url(${loadingpaperContent});
                  background-size:100%;background-position:center;background-repeat:no-repeat;"></div>`;
              overlayElement.style.pointerEvents = 'auto';
              viewer.addOverlay({ element: overlayElement, location: rect, placement: OpenSeadragon.Placement.CENTER });
              loadingOverlayBySerial.set(image.Serial, overlayElement); // refreshOne()에서 제거할 수 있음.
            } else {
              // 보기제한/속지 등 기존 처리
              if (userStore.limitation && image.idx > userStore.limitation - 1) {
                (async () => { await makingOverlay(image, i); })();
              }
              if (image.endpaper) makingEndpaper(image, i);
            }

            // 첫 "정상(비로딩)" 타일이 로드되면, 선행 타일 제거
            if (preAdded && preItem && !isLoading) {
              try { ev.item.viewer.world.removeItem(preItem); } catch (e) {}
              preItem = null;
              preAdded = false;
            }

            doneCount++;
            if (doneCount === addedCount) _result(ev);

            // 20260109 모바일 배경 이미지 숨기기 (PREVIEW_THEN_ORIGINAL에서만)
            if (mobile.value && mode.value === 'PREVIEW_THEN_ORIGINAL') {
              const tiledImage = ev.item;
              tiledImage.addOnceHandler('fully-loaded-change', () => {
                hideBg();
              });
            }
          }, error: function(event) {}
        });
      });

      // 이번 면이 전부 로딩 대체(= addTiledImage 하나도 없음)라면, 수동으로 마무리 처리
      if (addedCount === 0) {
        // _result(event) 없이도 필요한 최소 마무리
        canvasResizeCheck = [
          document.getElementById(viewer.id).offsetWidth,
          document.getElementById(viewer.id).offsetHeight
        ];

        // 홈 줌/위치 세팅
        try {
          viewer.viewport.minZoomLevel = viewer.viewport.getHomeZoom(true);
        } catch(e) {}
        viewer.viewport.goHome();
        // 로딩뷰면 Konva 숨김 유지
        // (이미 isLoadingView = true 상태일 것이므로 konvaStage는 생성 안 함)
        ready = true;
        $emit('paper-loaded');
      }
    }
    // 단/양면에 따른 OpenSeadragon Tile 추가
    if( tileSources.length == 1 ) { // 단면
      _drawLoop();

    } else {  // 양면
      let first = tileSources[0];

      if (first.loadingBase) {
        _drawLoop();               // 로딩면이면 선행 타일 추가하지 않음
      } else {

        viewer.addTiledImage({
          tileSource: first.imgJson,  // 이미지 하나가 객체 하나
          //x: i,                     // 이 값을 조정하여 다른 이미지와 겹치지 않도록 설정. 0과 1사이의 index
          //y: 0,
          // index: 0,
          opacity: 0,
          fitBounds: new OpenSeadragon.Rect(0, 0, Number(first.Pdf_width), Number(first.Pdf_height)),

          success: async function(ev) {
            preItem  = ev.item;   // 나중에 첫 정상 타일이 로드되면 제거
            preAdded = true;
            _drawLoop();
          }, error: function(event) {}
        });
      }
    }

    // isLoadingView 결정
    const allLoading = tileSources.length > 0 && tileSources.every(ts => ts.loadingBase);
    isLoadingView = allLoading;
    if (isLoadingView && konvaStage) {
      konvaStage.destroy();
      konvaStage = null;
    }

    // 그려야 되는 이미지들을 다 그린 후
    let _result = event => {
      //초기 canvas 사이즈 기록
      canvasResizeCheck = [
          document.getElementById(viewer.id).offsetWidth,
          document.getElementById(viewer.id).offsetHeight
        ];

      // 이번 뷰의 전체 월드 홈 바운즈를 명시적으로 잡아줌 (단면/양면 모두)
      const totalWidth = tileSources.reduce((sum, ts) => sum + Number(ts.Pdf_width || 0), 0);
      const maxHeight  = Math.max(...tileSources.map(ts => Number(ts.Pdf_height || 0)));
      currentHomeRect = new OpenSeadragon.Rect(0, 0, totalWidth, maxHeight);
      try { viewer.world.setHomeBounds(currentHomeRect); } catch (e) {}
      // 홈을 '같은 사각형'으로 정확히 맞춤 (로딩/완료 모두 동일 경로)
      viewer.viewport.fitBounds(currentHomeRect, true);
      viewer.viewport.minZoomLevel = viewer.viewport.getZoom();

      // loadingBase 모드면 Konva 전부 숨김
      if (isLoadingView) {
        if (konvaStage) { konvaStage.destroy(); konvaStage = null; }
        ready = true; // 다음 네비/줌 등은 동작해야 하므로 상태만 업데이트
        $emit('paper-loaded'); // 로딩 베이스 뷰도 준비 완료로 처리
        return;
      }

      // 기존 Konva 동작 (로딩이 아닐 때만)
      konva();
      if(props.searchKeyword.length != 0) searchHighlight(props.searchKeyword);
      selectedHighlightEvent(props.selectedSerial);
      ensureSelectedHighlightIfReady(); // 현재 상세보기 기사를 konva층에 선택된 기사(파란 테두리)로 반영
      $emit('paper-loaded'); // 정상 렌더 완료
    }
  }

  function singlePageImageViewer_Start(){
    viewer = new OpenSeadragon({
      id: "paper",

      // debugMode: true,
      // panHorizontal:             false,                // 이미지 수평방향 이동 가능 여부
      // panVertical:               true,                 // 이미지 수직방향 이동 가능 여부
      springStiffness:           15,                      // 드래그 강도 설정. 기본값은 6.5
      animationTime:             1,                       // 애니메이션 시간 설정. 기본값은 1.2초. 드래그 정도에 영향을 줌
      // constrainDuringPan:        true,                  // 이동 중 제약 여부

      //defaultZoomLevel:          "",                    // 기본 확대 수준. 실제 이미지 크기를 viewport width와 상대적으로 표현. 1 -> 꽉 채움
      maxZoomLevel:              "",                      // 최대 확대 수준. 1보다 큰 값.
      minZoomLevel:              "",                      // 최소 확대 수준. 1보다 작은 값.
      visibilityRatio:           1,                       // 가시도 비율. 드래그 시 이미지가 좌우상하 이동하는 정도를 조절.
      zoomPerScroll:             1.19,                    // 기본값 1.2. 1에 가까워질수록 스크롤 줌을 더 세밀하게 하여 단계가 더 많아짐.
      zoomPerScrollTemp:         1.5,
      zoomPerClick:              1.2,
      maxZoomPixelRatio:         2,
      minZoomImageRatio:         1,
      autoHideControls:          true,
      constrainDuringPan:        true,
      immediateRender:           true,
      alwaysBlend:               false,
      blendTime:                 0.1,

      zoomInButton:              "zoomIn",                // 확대 버튼 ID
      zoomOutButton:             "zoomOut",               // 축소 버튼 ID
      homeButton:                "goHome",                // 쪽맞춤 버튼 ID
      nextButton:                "",                      // 다음 페이지 버튼 직접 만듦. id=prevBtn
      previousButton:            "",                      // 이전 페이지 버튼 직접 만듦. id=nextBtn
      fullPageButton:            "",                      // full-page 기능 사용 안함

      preserveViewport:          true,                    // 다음 or 이전 기사 이동 시 canvas 위치가 보존됨
      preserveImageSizeOnResize: true,
      showFullPageControl:       false,

      gestureSettingsMouse:{
          scrollToZoom:   true,
          clickToZoom:    false,
          dblClickToZoom: false
      },
      gestureSettingsTouch:{
          dblClickToZoom: false,
          clickToZoom:    false,
          dragToPan:      false,
          scrollToZoom:   false,
          zoomToRefPoint: false,
      },
    });

    // konva 영역 생성
    let cCanvas = document.createElement('div');
    cCanvas.id = 'container';
    document.querySelector('.openseadragon-canvas').appendChild(cCanvas);

    viewer.addHandler('animation', function(event) {
      if (!konvaStage) return; // loadingBase 상태일 때 konva 층을 그리지 않음.
      // 기사 영역 하이라이팅 좌표값 변경, viewport 변경에 따라 해당 기사 영역도 이동
      konvaStage.children.forEach((stg) => {
        stg.children.forEach((shape) => { hilight(shape, stg.attrs.type == 'bookmark'); });
      });
      // resize observer
      if( canvasResizeCheck[0] != document.getElementById(viewer.id)?.offsetWidth
          || canvasResizeCheck[1] != document.getElementById(viewer.id)?.offsetHeight ){
        canvasResizeCheck = [
            document.getElementById(viewer.id)?.offsetWidth,
            document.getElementById(viewer.id)?.offsetHeight
          ];
        // 줄었다 늘었다 할때 혹여나 konva canvas 사이즈가 줄어들수 있기 때문에
        konvaStage.setWidth(viewer.viewport.getContainerSize().x);
        konvaStage.setHeight(viewer.viewport.getContainerSize().y);
        viewer.containerresize = true;
      }

      onResizeSyncBg(); // 모바일에서 '최대화' 버튼 클릭 시 배경 이미지 위치 동기화

    });

    //v4.1.0 부터 after-resize 존재
    //min zoom level reset
    viewer.addHandler('animation-finish', function(event){
      if (!konvaStage) return; // loadingBase 상태일 때 konva 층을 그리지 않음.
      if( viewer.containerresize ){
        let minZoom = viewer.viewport.getHomeZoom(true);
        viewer.containerresize = false;
        viewer.viewport.minZoomLevel = minZoom;
        konvaStage.setWidth(viewer.viewport.getContainerSize().x);
        konvaStage.setHeight(viewer.viewport.getContainerSize().y);
        // 현재 줌 상태가 min zoom 보다 크면 그냥 둔다.
        if( viewer.viewport.getZoom() < minZoom){
          //홈으로 가야 된다면 주석 해제
          viewer.viewport.goHome();
        }
      }

      onResizeSyncBg(); // 모바일에서 '최대화' 버튼 클릭 시 배경 이미지 위치 동기화
    });
  };

  // --- 폴링(10초 간격 재시도) 관리 ---
  const pollingTimers = new Map(); // key = serial, value = intervalId

  function stopAllPollers() {
    for (const id of pollingTimers.values()) clearInterval(id);
    pollingTimers.clear();
  }

  function stopPoller(serial) {
    const id = pollingTimers.get(serial);
    if (id) {
      clearInterval(id);
      pollingTimers.delete(serial);
    }
  }
  /**
   * 10초마다 info.json을 다시 GET.
   *  - 200 오면: 모든 폴러 중단 후 현재 idx 다시 로딩
   *  - 그 외(404 등): 조용히 무시 (알림 없음)
   */
  function startPollFor(serial) {
    if (pollingTimers.has(serial)) return;

    const id = setInterval(async () => {
      try {
        // 이미 정상전환 끝났으면 스킵
        const pageIdx = tileSources.findIndex(p => p?.Serial === serial);
        if (pageIdx !== -1 && tileSources[pageIdx].loadingBase === false) {
          stopPoller(serial);
          return;
        }

        const infoUrl = buildInfoUrl(serial);
        const res = await axios.get(infoUrl, { validateStatus: () => true });

        if (res.status === 200) { // 로딩완료됨.
          stopPoller(serial);
          await refreshOne(serial);
        }
      } catch (_) {}
    }, 10000);

    pollingTimers.set(serial, id);
  }

  /**
   * 1) loadingBase 면이 양면 중 부분 성공(양면 중 하나만 /info.json 응답 200)일 때
   * 2) loadingBase 면이 (/info.json 응답 200에 의해) 현재 화면에서 새로고침 없이 해당 면만 갱신되도록
   */
  // 현재 화면(한 뷰)에서만 알림 한 번만 띄우도록
  let alertedThisView = false;
  // serial별 아이템/오버레이 찾기 (시리얼별로 현재 보여지는 면 교체용)
  const itemBySerial = new Map();          // serial -> OpenSeadragon TiledImage item
  const boundsBySerial = new Map();        // serial -> OpenSeadragon.Rect
  const loadingOverlayBySerial = new Map();// serial -> overlay DOM
  const articlesBySerial = new Map();      // serial -> Articles (로딩 베이스 만들며 따로 보관)
  const refreshingSerials = new Set();     // 로딩완료 시 동일 면 호출 중복 방지 세트
  // (양면 중 한 면이라도 먼저 /info.json api 응답이 status:200 이라면 )한 시리얼만이라도 즉시 갱신(loadingBase → 실제 타일 교체)
  async function refreshOne(serial) {
    // 중복 진입 방지
    if (refreshingSerials.has(serial)) return;
    refreshingSerials.add(serial);

    try {
      const infoUrl = buildInfoUrl(serial);
      const res = await axios.get(infoUrl, { validateStatus: () => true });
      if (res.status !== 200) return;

      // 이미 업데이트 끝난 면이면 아무 것도 안 함
      const pageIdx = tileSources.findIndex(p => p?.Serial === serial);
      if (pageIdx === -1) return;
      if (tileSources[pageIdx].loadingBase === false) return; // 이미 정상 전환 끝난 상태

      // 실제 치수 반영
      const osdInfo = makeOsdIiifInfo(res.data);
      const realW   = Number(osdInfo.width);
      const realH   = Number(osdInfo.height);

      // 자리/기존 아이템
      const oldItem = itemBySerial.get(serial);

      // 1) 로딩 오버레이 제거 (API + DOM 폴백)
      const overlayEl = loadingOverlayBySerial.get(serial);
      if (overlayEl) {
        try { viewer.removeOverlay(overlayEl); } catch(_) {}
        try { overlayEl.remove(); } catch(_) {}
        loadingOverlayBySerial.delete(serial);
      }

      // 2) 기존 로딩 타일 제거
      if (oldItem) {
        try { viewer.world.removeItem(oldItem); } catch(_) {}
        itemBySerial.delete(serial);
      }

      // 3) tileSources의 메타 갱신 (W/H, info, loadingBase 해제, Articles 복구)
      tileSources[pageIdx].imgJson = (mode.value === 'AUTO_TILE')
        ? osdInfo
        : makeFullMaxTileSource(osdInfo, 'jpg', 8, false); // ORIGINAL_ONCE / PREVIEW_THEN_ORIGINAL
      tileSources[pageIdx].Pdf_width   = realW;
      tileSources[pageIdx].Pdf_height  = realH;
      tileSources[pageIdx].loadingBase = false;
      if (!tileSources[pageIdx].Articles) {
        const arts = articlesBySerial.get(serial);
        if (arts) tileSources[pageIdx].Articles = arts;
      }

      // 4) 레이아웃 재계산: 전체 x오프셋/홈바운즈 갱신 전에,
      //    "새 아이템을 같은 위치에" 먼저 추가할 필요 없음.
      //    -> boundsBySerial는 recalcLayoutAndHome()에서 재계산되므로
      //       새 rect를 구한 뒤 addTiledImage 해도 됨.
      //       먼저 bounds 테이블/아이템 bounds를 갱신한 뒤 새 타일 추가
      recalcLayoutAndHome(); // 여기서 boundsBySerial 가 최신 rect로 바뀜

      const newBounds = boundsBySerial.get(serial);
      if (!newBounds) return;

      // 5) 새 타일 추가 (최신 bounds로)
      await new Promise((resolve) => {
        const ts = (mode.value === 'AUTO_TILE')
        ? osdInfo
        : makeFullMaxTileSource(osdInfo, 'jpg', 8, false);
        viewer.addTiledImage({
          tileSource: ts,
          opacity: 1,
          fitBounds: newBounds,
          success: (ev) => {
            itemBySerial.set(serial, ev.item);

            // 실제 면으로 바뀌었으니 로딩 해제
            funcStore.$setPageLoading(pageSerialOf(serial), false);

            if (!konvaStage) konva();     // 스테이지가 없으면 생성
            addKonvaForSerial(serial);    // 해당 면 도형을 즉시 추가
            ensureSelectedHighlightIfReady(); // 현재 상세보기 기사를 konva층에 선택된 기사(파란 테두리)로 반영

            // 뷰 관련 최종 보정 (다시 한 번)
            recalcLayoutAndHome();
            // 로딩→실이미지로 바뀌더라도, 동일 홈 사각형을 재적용하여 뷰가 흔들리지 않게
            if (currentHomeRect) {
              viewer.viewport.fitBounds(currentHomeRect, true);
              viewer.viewport.minZoomLevel = viewer.viewport.getZoom();
            }
            relayoutKonva();              // 초기 프레임부터 정확한 위치/스케일
            resolve();

            // 20260109 모바일 배경 이미지 숨기기 (PREVIEW_THEN_ORIGINAL에서만)
            if (mobile.value && mode.value === 'PREVIEW_THEN_ORIGINAL') {
              const tiledImage = ev.item;
              tiledImage.addOnceHandler('fully-loaded-change', () => {
                hideBg(); // 20260109 모바일 배경 이미지 숨기기
              });
            }
          },
          error: () => resolve()
        });
      });
    } catch (_) {
      // noop
    } finally {
      refreshingSerials.delete(serial);
    }
  }
  // 갱신 직후 전체 레이어 한 번 재보정
  // 부분 갱신 흐름(refreshOne → addTiledImage(success))에서 아이템/홈바운즈를 갱신한 뒤,
  // 모든 도형을 한 번 훑으며 hilight를 호출해주면 초기 프레임부터 오차가 0이 됨.
  function relayoutKonva() {
    if (!konvaStage) return;
    konvaStage.getChildren().forEach(layer => {
      const isBookmark = layer?.attrs?.type === 'bookmark';
      layer.getChildren().forEach(shape => {
        const isImg = isBookmark || shape?.attrs?.type === 'bookmark';
        hilight(shape, isImg);
      });
    });
  }
  // 현재 상세보기로 열려 있는 기사(serial)를 Konva에 선택된 기사(파란색 테두리)로 표시
  function ensureSelectedHighlightIfReady() {
    if (!konvaStage) return;
    const serial = props.selectedSerial;
    if (!serial) return;
    const articleLayer = konvaStage.getLayers().find(l => l?.attrs?.type === 'article');
    if (!articleLayer) return;
    const shape = articleLayer.getChildren().find(s => s.getAttr('serial') === serial);
    if (!shape) return;
    // 기존 선택 상태를 일관되게 만들기 위해 기존 로직 재사용
    selectedHighlightEvent(serial);
  }

  // 특정 시리얼만 konva 도형 추가하는 헬퍼
  function addKonvaForSerial(serial) {
    if (!konvaStage) return;

    // tileSources에 없거나(로딩 베이스였다가 아직 복구 전) Articles가 없으면 보관본에서 복구
    let page = tileSources.find(p => p?.Serial === serial);
    if (!page) return;

    if (!page.Articles) {
      const arts = articlesBySerial.get(serial);
      if (arts) page.Articles = arts;
    }
    if (page.loadingBase || !page.Articles) return;

    const articleLayer  = konvaStage.getLayers().find(l => l?.attrs?.type === 'article');
    const bookmarkLayer = konvaStage.getLayers().find(l => l?.attrs?.type === 'bookmark');
    if (!articleLayer || !bookmarkLayer) return;

    // 여기서 '현재 페이지 인덱스'를 tileSources 기준으로 정확히 계산
    const pageIndex = tileSources.findIndex(p => p?.Serial === serial);
    const pageNumber = pageIndex + 1; // 양면에서 1 또는 2

    // 이미 그렸다면 스킵(같은 idx로 중복 방지)
    const already = articleLayer.getChildren().some(s => s.getAttr('idx') === page.idx);
    if (already) return;

    page.Articles.forEach((art, i) => {
      const isBookmarked = props.scrapSerialList.includes(art.Serial);
      const points = art.CoordinateList.Coordinate.join(',').split(',').map(Number);

      const shape = new Konva.Line({
        type: 'article',
        points, orgPoints: points,
        serial: art.Serial,
        page: pageNumber,
        fill: undefined,
        stroke: '#3182f6',
        strokeWidth: 3,
        opacity: 0,
        closed: true,
        idx: page.idx,
      });
      articleLayer.add(shape);
      hilight(shape);

      if (!(userStore.limitation && page.idx > userStore.limitation - 1)) {
        const icon = new Konva.Image({
          type: 'bookmark',
          serial: art.Serial,
          idx: page.idx,
          opacity: isMobileAddBtn(art.Serial) ? 0 : (isBookmarked ? 0.6 : 0),
          page: pageNumber,
          width: 18,
          height: 18,
        });
        bookmarkLayer.add(icon);
        changeBookmarkCursorFeature(icon);
        shape.setAttr('bookmark', icon);
        // 생성 직후 초기 위치/스케일 보정
        hilight(icon, true);
      }
    });

    // 북마크 아이콘 이미지 세팅
    const imgOn  = new Image(); imgOn.src  = staticVarStore.imageObjForBookmark;
    const imgOff = new Image(); imgOff.src = staticVarStore.imageObjForNone;
    bookmarkLayer.getChildren()
      .filter(s => s.getAttr('idx') === page.idx)
      .forEach(s => {
        const scrapped = props.scrapSerialList.includes(s.getAttr('serial'));
        s.setAttr('isBookmarked', scrapped);
        s.image(scrapped ? imgOn : imgOff);
      });

    articleLayer.draw();
    bookmarkLayer.draw();
  }

  // 로딩면(image.loadingBase)이 로딩 완료후 제대로 불러온 이미지로 갱신될 때 치수 확정 후, 레이아웃 위치 재계산 + 홈/줌 갱신
  function recalcLayoutAndHome() {
    // 1) 각 면의 x 오프셋 재계산 (양면일 때 특히 중요)
    let runningX = 0;
    for (const page of tileSources) {
      const rect = new OpenSeadragon.Rect(runningX, 0, Number(page.Pdf_width || 0), Number(page.Pdf_height || 0));
      boundsBySerial.set(page.Serial, rect);

      const item = itemBySerial.get(page.Serial);
      if (item) {
        try { item.setBounds(rect); } catch (_) {}
      }
      runningX += Number(page.Pdf_width || 0);
    }

    // 2) 홈/줌은 currentHomeRect로만 유지. 여기서 바꾸지 않음.
    if (currentHomeRect) {
      try { viewer.world.setHomeBounds(currentHomeRect); } catch (_) {}
      try {
        // 최소줌만 동기화 (뷰 이동 없음)
        viewer.viewport.minZoomLevel = viewer.viewport.getHomeZoom(true);
      } catch (_) {}
    }

    // 3) 보조: 혹시 모를 잔상 제거
    try { viewer.forceRedraw(); } catch (_) {}
  }

  // ==== DEMO ONLY: 임시 serial 치환 → 시간 지나면 자동 원복 ===================
  // const demoAliasMap = new Map([
  //   ['20251021jo00b01', '20251021jo00bbb'],
  //   ['20251021jo00c01', '20251021jo00ccc'],
  //   ['20251021jo00a01', '20251021jo00aaa'],
  // ]);

  // let demoTimersStarted = false;
  // function ensureDemoTimersOnce() {
  //   if (demoTimersStarted) return;
  //   demoTimersStarted = true;
  //   setTimeout(() => demoAliasMap.delete('20251021jo00b01'), 20000);
  //   setTimeout(() => demoAliasMap.delete('20251021jo00c01'), 40000);
  //   setTimeout(() => demoAliasMap.delete('20251021jo00a01'), 60000);
  // }

  // function getEffectiveSerial(serial) {
  //   ensureDemoTimersOnce();
  //   return demoAliasMap.get(serial) || serial;
  // }
  // ==== END DEMO ONLY ============================================================

  function buildInfoUrl(serial) {
    // const effective = getEffectiveSerial(serial); // ==== DEMO ONLY ====
    const effective = serial; // DEMO 모드가 아닐 때 주석 풀기

    const baseDir   = `${serial.substr(0,4)}/${serial.substr(8,4)}/${serial.substr(0,8)}/`;
    const pathParam = encodeURIComponent(`${baseDir}${effective}org.png`);
    // return `https://pmtest1.scrapmaster.co.kr/iiif/3/${pathParam}/info.json`; // 이미지 테스트 서버 접속 - 도메인만 변경해서 사용!
    return `https://api-server.scrapmaster.co.kr/iiif/3/${pathParam}/info.json`; // 실제 사용중인 이미지 서버 접속
  }

  // Canvas 하이라이팅 lib
  let konvaStage = null;
  let presentSerial = '';
  function konva() {
    // 재 생성 방지를 위해
    if( konvaStage ) konvaStage.destroy();
    let odg = viewer.viewport.getContainerSize();
    let location = document.getElementById('paper').getBoundingClientRect();
    konvaStage = new Konva.Stage({
      container: 'container',
      width: window.outerWidth - location.x,
      height: odg.y,
    });

    let articleLayer = new Konva.Layer({type: 'article'});// 지면 이미지 - 기사 영역 하이라이트 층
    let bookmarkLayer = new Konva.Layer({type: 'bookmark'});// 지면 이미지 - 북마크 아이콘 (여부 확인 및 생성 버튼) 층

    konvaStage.removeChildren(); // stage 내 모든 Layer 초기화
    konvaStage.add(articleLayer); // article layer 추가
    konvaStage.add(bookmarkLayer);  // bookmark layer 추가

    let isBookmarked = null;// 북마크 여부
    let imgShapes = [];
    // 기사 하이라이팅 영역 지정
    tileSources.forEach((page, i) => {
      if (page.loadingBase) return; // 로딩면은 Konva 생성 안 함
      if(!page.Articles) return;
      let articles = page.Articles;
      articles.map((art) => {
        isBookmarked = props.scrapSerialList.includes(art.Serial);
        let points = art.CoordinateList.Coordinate.join(',').split(',').map(c => c*1);
        let articleAreaShape = new Konva.Line({
            type: 'article',    points: points,
            orgPoints: points,  serial: art.Serial,
            page: i + 1,        fill: undefined,
            stroke: '#3182f6',  strokeWidth: 3,
            opacity: 0,         closed: true,
            idx: page.idx,
        }); // closed는 기본 옵션이다. true 설정시 도형이 완성 되었다는 의미로 화면에 표시된다. 없으면 화면에 표시 X
        articleLayer.add(articleAreaShape);

        // 기사 영역이랑 북마크 이미지 관계 정립해야됨 기사 영역의 x,y 좌표와 point 를 합산해야 북마크 위치가 나옴
        // shape가 각각 돌아가기 때문에 영역과 북마크 위치를 연결해야됨
        // 스크랩 목록에 존재하는 기사라면 bookmark 표시를 해줌
        if(!(userStore.limitation && page.idx > userStore.limitation-1)) { // 보기 제한 페이지에서는 북마크 여부&생성 아이콘 생성하지 않아도 된다는 의미.
          let timg = new Konva.Image({
            type: 'bookmark',   serial: art.Serial, idx: page.idx,
            opacity: isMobileAddBtn(art.Serial) ? 0 : isBookmarked ? 0.6 : 0,
            page: i + 1,
            width: 18,
            height: 18,
          });
          // if( isBookmarked ) timg.setAttr('unchanged', true);
          imgShapes.push(timg);
          bookmarkLayer.add(timg);
          // 1) 모바일이고 북마크생성버튼이면 실행하지 않아도 된다는 의미.
          if( !isMobileAddBtn(art.Serial) ) changeBookmarkCursorFeature(timg);
          // 기사와 북마크 연결
          articleAreaShape.setAttr('bookmark', timg);
          // 생성 직후 초기 위치/스케일 보정 (OSD 애니메이션이 없을 때 대비)
          hilight(timg, true);
        }
        // 정확한 좌표 조정
        hilight(articleAreaShape);
      })
    });
    // bookmark 이미지 로딩 shape 를 Layer 추가 후 이미지를 로딩해야 정상 로딩이 됨
    let imageObjForBookmark = new Image(); // 북마크된 기사인 경우 아이콘 이미지 객체
    imageObjForBookmark.src = staticVarStore.imageObjForBookmark;
    let imageObjForNone = new Image(); // 북마크 안된 기사인 경우 아이콘 이미지 객체
    imageObjForNone.src = staticVarStore.imageObjForNone;
    imgShapes.forEach( (a, i) => {
      if(props.scrapSerialList.includes(a.attrs.serial)) {
        a.setAttr('isBookmarked', true);
        a.image(imageObjForBookmark);
      } else {
        a.image(imageObjForNone);
      }
    });

    let _$detail = function(e) {
      const shape = _$detail.shape?.attrs;
      if (!shape) return;

      // 클릭 막아야 하는 조건은 "return"으로 먼저 탈출
      if (shape.unclick) return;            // 키워드 하이라이트 등 클릭 금지
      // if (props.isTtsPlaying) return;       // TTS 재생 중 클릭 금지

      if (shape.type === 'article') {       // 기사 클릭 시
        presentSerial = shape.serial;
        $emit('detail-view', shape.serial, undefined, undefined, 'newsImage');
      } else if (shape.type === 'bookmark') {// 북마크 아이콘 클릭 시 -> 웹 && 북마크 되어 있지 않은 기사는 북마크 생성됨 / props.scrapSerialList를 watch로 감시 -> 북마크 생성/삭제에 따른 아이콘 css 반영 중.
        if (!isMobileAddBtn(shape.serial)) {
          if (shape.isBookmarked) return;
          $emit('add-bookmark', shape.serial, null, true, null);
        }
      }

      // (옵션) 필요하면 여기서만 preventDefault
      e?.preventDefault?.();
    };

    let _$clickArt = (remove, add) => {
      if(!konvaStage) return;
      let cCanvas = konvaStage.content;
      if( remove ) cCanvas.removeEventListener('click', _$detail);
      if( add ) cCanvas.addEventListener('click', _$detail);
    };

    //모든 이벤트 초기화
    konvaStage.removeEventListener();
    // 기사 선택 이벤트 시작
    let touchStartTime = 0;
    let touchStartX = 0;   // 손가락 이동방향에 따라 앞으로 뒤로
    let touchStartY = 0;   // 손가락 이동방향에 따라 위로 아래로
    let touchesCount = 0;
    let startEvent = function( e ) {
        touchStartTime = new Date().getTime();
        let ee = e.evt.targetTouches?.[0] || e.evt;
        touchStartX = ee?.clientX;
        touchStartY = ee?.clientY;
        touchesCount = e.evt.touches?.length || 0; // 터치 손가락 개수 저장
        let shape = e.target;
        if (!('container' in shape.attrs)) {
            if( !shape.attrs.unchanged && !mobile.value ) shape.opacity(0.6);
            changeBookmarkFeature(2, shape);
            _$detail.shape = shape;
            _$detail.created = true;

            _$clickArt(1, 1);
            /**
             * Article detail process
             * 1. mouseover -> click
             * 2. mouseover -> canvas-drag-end -> mousemove -> click
            */
        }
    }
    // 기사 선택 이벤트 종료
    let endEvent = function( evt ){
      let shape = evt.target;
      if (!('container' in shape.attrs)) {//기사 위라면
        if(!shape.attrs.unchanged) shape.opacity(0);
        changeBookmarkFeature(3, shape);
      }
    }
    // 기사 선택 이벤트 진행 도중 순수하게 클릭하는 행위가 아니면 지면 이미지를 이동할 의사가 있다고 판단하여 기사 선택 이벤트 제거
    let moveEvent = function( evt ){
        let shape = evt.target;
        if (!('container' in shape.attrs)) {
            if( !_$detail.created ){
            _$clickArt(1, 1); _$detail.created = true;
          }
        }
    }
    konvaStage.on('mouseover touchstart', startEvent);
    konvaStage.on('touchend', function (e) {
      const touchEndTime = Date.now();
      const touchDuration = touchEndTime - touchStartTime;

      // 1) 긴 or 손가락 2개 이상 동시 터치 차단
      if ((touchDuration > 300 && touchesCount === 1) || touchesCount >= 2) {
        endEvent(e);
        return;
      }

      const currentX = Math.trunc(e.evt.changedTouches[0]?.clientX); // 소수점 이하 만큼 오차는 무시
      const currentY = Math.trunc(e.evt.changedTouches[0]?.clientY);

      // 2) 줌 상태면 플릭 금지
      let zoomedIn = false;
      try {
        const vp = viewer?.viewport;
        if (vp?.getZoom && vp?.getHomeZoom) {
          const curZoom  = vp.getZoom(true);
          const homeZoom = vp.getHomeZoom(true);
          const EPS = 1e-4;
          zoomedIn = (curZoom > homeZoom + EPS);
        }
      } catch (e) {}

      // 3) 플릭(빠른 스와이프) 처리
      const minFlickX = 100;
      const minFlickY = 100;
      if (!zoomedIn && touchDuration <= 200) {
        if (touchStartX >= currentX + minFlickX && Math.abs(touchStartY - currentY) <= minFlickY) {
          $emit('pre-next', 1);
          endEvent(e);
          return;
        } else if (touchStartX + minFlickX <= currentX && Math.abs(touchStartY - currentY) <= minFlickY) {
          $emit('pre-next');
          endEvent(e);
          return;
        }
      }

      // 4) 탭(클릭) 처리: "너무 짧은 탭"은 무시하고 여기서만 끝내기
      const TAP_MIN_MS = 15;
      if (touchDuration < TAP_MIN_MS) {
        endEvent(e);
        return;
      }

      const minTouch = 10;
      const movedX = Math.abs(touchStartX - currentX);
      const movedY = Math.abs(touchStartY - currentY);
      const isTapMove = (movedX <= minTouch && movedY <= minTouch);

      if (isTapMove) {
        _$detail(e);
      }

      endEvent(e);
    });
    // 지면을 드래그 할때 클릭 이벤트가 있으면 영역을 벗어나더라도 클릭 이벤트가 발생하여 드래그 시 클릭 이벤트 제거
    viewer.addHandler('canvas-drag-end', function() {
      _$detail.created = false;
      _$clickArt(1, 0);
    });
    // 기사 영역에서 마우스가 밖으로 나가면 클릭 이벤트 제거
    konvaStage.on('mouseout', endEvent);
    // 드래그 등의 이유로 클릭 이벤트가 없어졋을 경우를 대비하여 기사 영역 위에서 살짝 움직이면 다시 클릭 이벤트 생성
    konvaStage.on('mousemove touchmove', moveEvent);
    // 모든 준비가 되었다면
    ready = true;
  }

  // 모바일일 때는 북마크 '생성'버튼이 안 나오도록, 북파크가 된 기사일 경우는 항시 떠 있도록
  function isMobileAddBtn(serial) {
    return mobile.value && !props.scrapSerialList.includes(serial);
  }

  // 북마크 생성 버튼일 때에만 마우스 커서가 변경되도록
  function changeBookmarkCursorFeature(shape, notYet=false) {
    let container = shape.getStage().container();
    // 이전 이벤트가 존재 할 수 있으니 off 해주고 시작
    shape.off('mouseover mouseout');
    // 중앙 -지면 이미지 상 북마크 생성 버튼 클릭 했을 때 (아직 북마크가 생성 됐는지 안 됐는지는 확인 X)
    // 현재 페이지의 북마크 확인 아이콘 or 생성 버튼 상태 초기화/갱신 시
    shape.on('mouseover', () => {
      container.style.cursor =
        (notYet || props.scrapSerialList.includes(shape.attrs.serial)) ? 'default' : 'pointer';
    });
    shape.on('mouseout', () => { container.style.cursor = 'default'; });
  }

  // 중앙 - 지면 이미지 모양 변형 함수
  function changeBookmarkFeature(eventType=0, selectedShape){
    let TYPE_RESET = 0, TYPE_CLICK = 1, TYPE_MOUSE_OVER = 2, TYPE_MOUSE_OUT = 3;

    if (!konvaStage) return;// 아직 konva 층이 그려지지 않았다면 패스.
    let target = selectedShape || konvaStage.getChildren().filter(child => child.attrs.type == 'bookmark')[0]; // 북마크 아이콘이 만들어진 층.

    if(userStore.limitation && target.getAttr("idx") > userStore.limitation-1) return;

    // eventType : 이벤트 종류( 0 : 초기화, 1 : click, 2 : hover, 3: hover 종료 )
    switch (eventType) {
      case TYPE_RESET: // 초기화
        let imageObjForBookmark = new Image(); // 북마크된 기사인 경우 아이콘 이미지 객체
        imageObjForBookmark.src = staticVarStore.imageObjForBookmark;
        let imageObjForNone = new Image(); // 북마크 안된 기사인 경우 아이콘 이미지 객체
        imageObjForNone.src = staticVarStore.imageObjForNone;
        target.getChildren().forEach((shape) => {
          let serial = shape.getAttr('serial');
          let isClicked = shape.getAttr('isPrevClick');
          let isScrap = props.scrapSerialList.includes(serial);
          if( ( mobile.value )                         // 모바일인 경우. CASE: TYPE_CLICK에서 opacity를 따로 주고 있지 않으므로..
                || ( !mobile.value && !isClicked ) )   // 모바일 아닌 경우. 선택된 기사의 북마크는 영향을 받지 않는다.
            shape.opacity(isClicked ? 1 : isScrap ? 0.6 : 0);
          shape.setAttr('image', isScrap ? imageObjForBookmark : imageObjForNone);
          shape.setAttr('isBookmarked', isScrap ? true : false);
          changeBookmarkCursorFeature(shape);
        });
        break;

      case TYPE_CLICK: // click 생성 및 종료
        let bookmark = selectedShape.getAttr('bookmark');
        bookmark.setAttrs({isPrevClick: true, unchanged: true});
        if( isMobileAddBtn(bookmark.getAttr('serial')) && !bookmark.getAttr('isBookmarked') )
          bookmark.opacity(0);
        else bookmark.opacity(1);
        bookmark.getLayer().moveToTop();
        break;

      case TYPE_MOUSE_OVER: // hover 생성
        // 기사 영역 전체에 호버됐을 때 target.attrs.bookmark
        // 북마크에만 호버됐을 때 target.attrs
        let hoverTarget = target.getAttr('bookmark') || target;
        if( !hoverTarget.getAttr('unchanged') )
          hoverTarget.opacity(isMobileAddBtn(hoverTarget.getAttr('serial')) && !hoverTarget.getAttr('isBookmarked') ? 0 : 0.6 );
        break;

      case TYPE_MOUSE_OUT: // hover 종료 - 'mouseout'에서 실행 시 지면 이미지 밖으로 마우스가 이동하는 경우에도 이전 호버된 기사에 대한 처리를 할 수 있기 위해 case3에 위치시킴.
        target = target.getAttr('bookmark') || target;
        let serial = target.getAttr('serial');

        if(!serial) return;// serial 정보가 담기지 않은 키워드 하이라이팅 konva층에 대해서.

        if( target.getAttr('isPrevClick') && !isMobileAddBtn(serial) ) // 선택된 기사의 bookmark
          target.opacity(1);
        else if( target.getAttr("isBookmarked") )  // 스크랩된 북마크
          target.opacity(0.6);
        else target.opacity(0);
        break;

      default:
        break;
    }

  }

  // 지면에 기사 하이라이트 하기
  function hilight(shape, isImage=false) {
    funcStore.$keywordHilightPosision(viewer, shape, props.pageSide, isImage);
  }

  //검색어 하이라이트
  async function searchHighlight(keyword){
    if (!konvaStage) return;
    // 검색어 하이라이트 기능 제한 된 사용자는 빠져나가도록.
    if( !userStore.$isOption(props.mediaSeq, 'hilight') ) return;

    if (keyword.length === 0 && userJS.noResult.value) { // 검색 결과가 없습니다 처리하는 경우(keyword : [], noResult.value : true) 이전 하이라이트 모두 없애기
      let keywordLayers = konvaStage.getChildren().filter(child => child.attrs.type == 'keyword');
      keywordLayers.forEach(child => child.destroy());
      userJS.searchHiShapesLayer.value = null;
      return;
    }
    if( keyword == undefined || keyword.length === 0 ) return; // 프로젝트 첫 접속 시.

    // 라인 배열로 치환
    let _$ractToLine = (coors) => {
      let [x,y,x1,y1] = coors.split(',').map(c => c*1);
      return [ x, y, x1, y, x1, y1, x, y1, x, y ];
    }
    //기존 키워드 배열이 있다면 모두 제거
    let keywordLayers = konvaStage.getChildren().filter(child => child.attrs.type == 'keyword');
    keywordLayers.forEach(child => child.destroy());
    userJS.searchHiShapesLayer.value = null;

    let params = new FormData;
    params.append('keyword', keyword.join(' '));
    params.append('mediaSeq', props.mediaSeq);
    let shapesLayer = null;
    for (const [i, paper] of tileSources.entries()) {
      if (paper.endpaper || paper.loadingBase) continue;
      if(paper.endpaper) continue;// 속지는 키워드 하이라이팅 영역 생기지 않도록 처리.
      params.set('serial', paper.Serial);
      try {
        let res = await userJS._api.paperInfo.all(params);
        let articles = res.ArticleList.Article;
        if( !Array.isArray(articles) ) articles = [articles];
        shapesLayer = new Konva.Layer({type: 'keyword'});
        for (const art of articles) {
          if(!userJS.searchResultSerialArr.value.includes(art.Serial)) continue; // 검색 결과(AND검색조건) 기사들의 serial 배열에 부합하는 기사들만 키워드 하이라이팅되도록.
          let scoors = art.SearchWordCoordinate;
          Object.keys(scoors).map((key) => {
            scoors[key].map((coords) => {
                let coors = _$ractToLine(coords);
                let shape = new Konva.Line({
                    points: coors,    orgPoints: coors,
                    page: i + 1,      fill: userStore.searchHiColor,
                    opacity: 0.5,     unchanged: true,
                    unclick: true,    closed: true
                });
                hilight(shape);
                shapesLayer.add(shape);
            });
          }); // scoors loop
        }//article loop
        konvaStage.add(shapesLayer);
      } catch (error) {
        console.error('Error fetching paper info:', error);
      }
    }
    if(shapesLayer) userJS.searchHiShapesLayer.value = shapesLayer;
  }

  // 재 사용 안하면 watch 내부에 넣을 예정
  function selectedHighlightEvent(selectedSerial) {
    if (!konvaStage) return;                 // 로딩뷰 등
    if (!selectedSerial) return;             // 빈 값이면 종료

    const articleLayer =
      konvaStage.children.find(ch => ch?.attrs?.type === 'article');
    if (!articleLayer) return;

    // 선택된 기사의 영역 정보를 가져온다.
    const selectedShape = articleLayer.getChildren()
      .find(art => art.getAttr('serial') === selectedSerial);

    // 상세보기 serial을 '' 초기화 할 경우가 있다 그럴 경우 하이라이트 제거만 하고 넘어간다.
    if (!selectedShape) return;

    // (pageIndex 같은 추가 로직이 필요하다면)
    const pageIndex = ((selectedShape.getAttr('page') || 1) - 1);

    // 기존에 있던 selected 레이어 비우기
    // 선택 했던 기사 영역을 저장하고 있는 Layer가 존재하는지 체크
    const befLayer = konvaStage.getLayers()
      .find(ch => ch?.attrs?.type === 'selected');
    if (befLayer) {
      const bookmark = befLayer.getChildren()[0].getAttr('bookmark');
      bookmark?.setAttrs({ isPrevClick: false, unchanged: false });
      bookmark?.opacity(bookmark.getAttr('isBookmarked') ? 0.6 : 0);
      befLayer.destroy();
    }

    // 선택 되었다는 표시
    const clone = selectedShape.clone({
      fill: 'rgba(49, 130, 246, 0.05)',
      unclick: true,
      unchanged: true,
      stroke: '#3182f6',
      opacity: 1,
      strokeWidth: 3,
    });

    // 선택된 기사 Layer 생성, 별도의 Layer로 관리
    const selectedLayer = new Konva.Layer({ type: 'selected', serial: selectedSerial });
    selectedLayer.add(clone);
    konvaStage.add(selectedLayer);
    changeBookmarkFeature(1, selectedLayer.getChildren().find(art => art.attrs.serial == selectedSerial));
  }

  // ====================================================================================

  onMounted(() => {
    // 지면 이미지 - openseadragon viwer 생성 및 속성 설정
    singlePageImageViewer_Start();
    // 전체 지면 정보 변경 or 페이지 이동이 발생 했을 때
    watch( [() => props.papers, () => props.thumbIdx, () => props.pageSide], (n, o, t) => {
      ready = false;
      viewer.close();
      // console.log("별지 페이지 이동serial 초기화 여부 확인(빈 문자열이면 초기화 된 것 ) : " +userStore.localpageSerial);
      // console.log(n[1]);

      // 20250923 최지현 - 별지 페이지 바로가기 링크로 접속 했을 때,
      // 첫 번째 지면 로딩은 하지 못하도록.
      // -> 이후 별지 페이지 이동serial이 초기화(빈 문자열화)되도록 하여 return 되지 않음.
      if(userStore.localpageSerial !== '' && n[1] == 0) return;

      imageViewer_Images(props.thumbIdx);
    })

    watch( () => [props.isFullScreen, props.vh], () => {
      let zoomLevel = viewer.viewport.getZoom()+0.0000000000000001; // 최대화 버튼을 누를 때마다 줌 레벨이 조금이라도 바뀌어야 기사영역 하이라이트 위치가 함께 갱신됨
      if(viewer) viewer.viewport.zoomTo(zoomLevel);
    })
    // 검색어가 변경 되었을 경우 실행됨
    watch( () => props.searchKeyword, (newValue) => {
      searchHighlight(newValue);
    });
    // 지면이미지 클릭 또는 기사목록에서 특정 기사 제목 클릭시 실행됨
    watch( () => props.selectedSerial, (newVal) => {
      if( ready ) selectedHighlightEvent(newVal);
    });
    // 지면 이미지 상 북마크 여부에 따라 북마크 아이콘 opacity 변경값 즉시 반영.
    watch(()=>props.scrapSerialList, ()=>{
      changeBookmarkFeature();
    })
  });
  onUnmounted(() => { // 컴포넌트가 화면에서 사라질 때(라우트 이동, 탭/모달 닫기, v-if 로 언마운트 등) 돌고 있던 10초 폴링(interval) 을 전부 끊어주기.
    stopAllPollers(); // loadingBase일 때 해당 loadingBase를 열고 있는 상태에서 계속해서 /info.json api를 10초마다 status:200 응답이 올 때까지 호출.
    overlayObjUrlCache.forEach(url => { try { URL.revokeObjectURL(url); } catch {} });
    overlayObjUrlCache.clear();
  });
/*
  // @overlapmedia/imagemapper : image mapper
*/
</script>

<style scoped>
  /* 20260109 모바일에서 (고해상도 이미지 불러오기 전에 시간 차 줄이기 위한) 저해상도 이미지 background 설정 */
  /* 배경은 항상 OSD 뒤 */
  #paper-background{
    position: absolute;
    inset: 0;
    z-index: 0;
    pointer-events: none;
    overflow: hidden;
  }
  /* low-res img는 JS로 translate/width/height 세팅 */
  #paper-background img{
    position: absolute;
    left: 0;
    top: 0;
    transform-origin: 0 0;
  }
  /* OSD 컨테이너는 항상 bg 위 */
  #paper{
    position: relative;
    z-index: 1;
  }

  .prev-next { top: 0; width: 60px; z-index: 500; position: absolute; top: 50%; display: flex; align-items: center; justify-content: space-around; }
  .prev-next.prev { left: 0; z-index: 25; }
  .prev-next.next { right: 0; z-index: 25; }

  /* 디자인 후속 작업 */
  #imageControlBtns .v-btn--variant-elevated { background: unset; }
  #prevBtn { transition: opacity 0s ease 0s; opacity: 0.2; cursor: no-drop; }
  #nextBtn { transition: opacity 0s ease 0s; opacity: 1; cursor: pointer; }

</style>
